// modules
import { createAction } from 'redux-actions'
// setup
import { dispatch } from '../setup/redux'

// reducer
export const ADD_TO_WAPP_POOL = 'ADD_TO_WAPP_POOL'
export const addToWappPool = createAction(ADD_TO_WAPP_POOL)
export const dispatchAddToWappPool = wappInfo =>
  dispatch(addToWappPool(wappInfo))

export const REMOVE_FROM_WAPP_POOL = 'REMOVE_FROM_WAPP_POOL'
export const removeFromWappPool = createAction(REMOVE_FROM_WAPP_POOL)
export const dispatchRemoveFromWappPool = wappSessionId =>
  dispatch(removeFromWappPool(wappSessionId))

export const SET_WAPPRUNNER_STAGE = 'SET_WAPPRUNNER_STAGE'
export const setWapprunnerStage = createAction(SET_WAPPRUNNER_STAGE)
export const dispatchSetWapprunnerStage = wapp =>
  dispatch(setWapprunnerStage(wapp))

export const SET_WAPP_CUSTOM_ACTIONS = 'SET_WAPP_CUSTOM_ACTIONS'
export const setWappCustomActions = createAction(
  SET_WAPP_CUSTOM_ACTIONS,
  (wappSessionId, customActions) => ({
    wappSessionId,
    customActions,
  }),
)
export const dispatchSetWappCustomActions = (...args) =>
  dispatch(setWappCustomActions(...args))

export const SET_WAPP_BOOKMARK_DATA = 'SET_WAPP_BOOKMARK_DATA'
const setWappBookmarkData = createAction(
  SET_WAPP_BOOKMARK_DATA,
  (wappSessionId, bookmarkData) => ({ wappSessionId, bookmarkData }),
)
export const dispatchSetWappBookmarkData = (...args) =>
  dispatch(setWappBookmarkData(...args))
